/** @format */

import { ChangeDetectionStrategy, Component, computed, inject, input } from '@angular/core';

import { Scene7Service, TaggingService } from '@shared/data-access/services';

@Component({
  selector: 'shared-media-component-scene7',
  templateUrl: './media-scene7.component.html',
  providers: [TaggingService],
  imports: [],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class MediaScene7Component {
  // Inputs as signals
  readonly altText = input<string>();
  readonly image = input<string>();
  readonly mobileImg = input<string>();
  readonly gif = input<string>();
  readonly gifMobile = input<string>();
  readonly itemTitle = input<string>();
  readonly imagePreset = input<string>();
  readonly willLazyLoad = input<boolean>(true);

  // Services
  private readonly taggingService = inject(TaggingService);
  private readonly scene7Service = inject(Scene7Service);

  // Computed signals for template values
  protected readonly gifUrl = computed(() => {
    const gifImage = this.gif();
    return gifImage ? this.scene7Service.scene7Url(gifImage, 'gif', true) : null;
  });

  protected readonly gifMobileUrl = computed(() => {
    const gifMobileImage = this.gifMobile();
    return gifMobileImage ? this.scene7Service.scene7Url(gifMobileImage, 'gif', true) : null;
  });

  protected readonly imageUrl = computed(() => {
    const img = this.image();
    const preset = this.imagePreset();
    return img ? this.scene7Service.scene7Url(img, preset, false) : null;
  });

  protected readonly mobileImgUrl = computed(() => {
    const mobileImage = this.mobileImg();
    const preset = this.imagePreset();
    return mobileImage ? this.scene7Service.scene7Url(mobileImage, preset, false) : null;
  });

  protected readonly altTagText = computed(() => {
    const alt = this.altText();
    const title = this.itemTitle();
    return this.taggingService.altTag(alt || '', title || '');
  });
}
